import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../api";
import axios from "axios";
import logo from "../img/logo_apk.png";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function SignIn() {
  const [nik, setNik] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/login`, {
        nik,
        psw: password,
      });
      const data = res.data;

      if (data.message === "Login berhasil") {
        localStorage.setItem("userToken", data.token);
        const userToStore = { ...data.user, foto: data.user.path_profil };
        delete userToStore.path_profil;
        localStorage.setItem("user", JSON.stringify(userToStore));
        navigate("/menu");
      } else {
        alert(data?.error || "Login gagal");
      }
    } catch (err) {
      alert(err.response?.data?.error || "Koneksi gagal ke server");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div className="signin-wrapper">
        <div className="logoSection">
          <img src={logo} alt="Logo" className="logoImage" />
        </div>

        <div className="card">
          <h4 className="title">Selamat Datang!</h4>
          <p className="subtitle">
            Masukan NIK (Nomor Induk Karyawan) dan Password untuk menggunakan
            aplikasi
          </p>
          <form onSubmit={handleLogin} style={styles.form}>
            <div style={styles.inputGroup}>
              <label htmlFor="nik" style={styles.label}>
                NIK
              </label>
              <input
                id="nik"
                type="text"
                placeholder="Masukkan NIK"
                value={nik}
                onChange={(e) => setNik(e.target.value)}
                style={styles.input}
                required
              />
            </div>

            <div style={{ ...styles.inputGroup, position: "relative" }}>
              <label htmlFor="password" style={styles.label}>
                Password
              </label>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Masukkan password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                required
              />
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "33px",
                  color: "grey",
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </div>

            <button
              type="submit"
              style={{
                ...styles.button,
                backgroundColor: isLoading ? "#95a5a6" : "#2980b9",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Memproses..." : "Login"}
            </button>
          </form>
        </div>
      </div>

      {/* Media query khusus */}
      <style>
        {`
          .signin-wrapper {
            display: flex;
            flex-direction: row;
            background-color: #ffffff;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            max-width: 1000px;
            width: 100%;
          }
          .logoSection {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            border-right: 1px solid #ddd;
          }
          .logoImage {
            width: 400px;
            height: auto;
          }
          .card {
            flex: 1;
            padding: 40px;
          }
          .title {
            font-size: 24px;
            font-weight: 600;
            color: #2980b9;
            margin-bottom: 30px;
            text-align: center;
          }
          .subtitle {
            font-size: 16px;
            font-weight: 400;
            color: #b2b2b2ff;
            margin-bottom: 20px;
        
          }

          @media (max-width: 768px) {
            .signin-wrapper {
              flex-direction: column;
              align-items: center;
              padding: 20px;
              max-width: 90%;
            }
            .signin-wrapper > div {
              width: 100% !important;
              border-right: none !important;
              padding: 0 !important;
            }
            .signin-wrapper .logoSection {
              border-right: none !important;
              margin-bottom: 30px;
              text-align: center;
            }
            .signin-wrapper .logoImage {
              display: block;
              width: 200px;
              margin: 0 auto;
            }
            .signin-wrapper .card {
              padding: 0 !important;
            }
            .signin-wrapper .title {
              margin-bottom: 20px;
            }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(to right, #ecf0f1, #ffffff)",
    fontFamily: "Segoe UI, sans-serif",
    padding: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: { textAlign: "left" },
  label: {
    display: "block",
    marginBottom: "6px",
    color: "#34495e",
    fontWeight: "bold",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "12px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    outline: "none",
  },
  button: {
    padding: "12px",
    fontSize: "16px",
    color: "white",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default SignIn;
